export function clientClientCasesApi(path: string) {
  return {
    path,
  };
}
